// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"88":"db575139","153":"909e2556","212":"ad1ca921","251":"42b0f3fb","452":"746514bb","927":"c2f5297c"}[chunkId] + ".css";
};